/** FAST v3 Schedule A (fi.co/fast, July 2026). Keys are calculator UI labels. */
export const FAST_MATRIX: Record<string, Record<string, number>> = {
  'Pre-seed': { Standard: 0.5, Strategic: 0.75, Expert: 1.0 },
  Seed: { Standard: 0.25, Strategic: 0.5, Expert: 0.75 },
  'Series A': { Standard: 0.1, Strategic: 0.25, Expert: 0.5 },
}
export const CAL_MULT: Record<string, number> = { Operator: 0.85, Executive: 1.0, Notable: 1.2 }
export const INTRO_MULT: Record<string, number> = { None: 1.0, Customers: 1.1, Investors: 1.2, Both: 1.3 }
